import {Component, OnInit, HostListener} from "@angular/core";
import {CommonHelper} from "../../shared/helpers/CommonHelper";
import {Json2csvService} from "../../services/json2csv.service";
import {UrlBuilderFactory} from "../../shared/factories/url-builder.factory";
import * as _ from 'lodash';
import * as moment from "moment";
import { DropdownSettingsFactory } from "../../shared/factories/dropdown/dropdown-settings.factory";
import { DropdownItemFactory } from "../../shared/factories/dropdown/dropdown-item.factory";
import { ToastsManager } from "ng2-toastr";
import { RefundFiltersFactory } from "../../shared/factories/refunds/filters.factory";
import { LocalStorage } from "../../shared/wrappers/LocalStorage";
import { RefundsService } from "../../services/refund.service";
import { CompanyService } from "../../services/billing-letter/company.service";
import { ProjectFinancialService } from "../../services/projectFinancial.service";
import { IndustriesService } from '../../services/industries.service';
import { ExcellenceCentersService } from "../../services/excellenceCenters.service";
import { Refund } from "../../models/Refund.model";
import { GroupDivision } from "../../shared/enums/GroupDivision";
import { VerifyCreatedDate } from "../../shared/helpers/verify-created-date";
import { Router } from "@angular/router";
import { GUARDS } from "../../shared/auth/Roles";

@Component({
    selector: "app-refunds",
    templateUrl: "./refunds-report.component.html",
    styleUrls: ["./refunds-report.component.css"]
})
export class RefundsReportComponent implements OnInit {
    refunds = [];
    commonHelper: CommonHelper = new CommonHelper();
    itemsPerPage: number[] = [5, 10, 50, 100];
    totalItems: number = 0;
    currentPage: number = 1;
    output:string = '';
    datePattern = /^(0[1-9]|1[0-9]|2[0-9]|3[01]).(0[1-9]|1[012]).[0-9]{4}$/i;
    mask = [/[0-3]/,/[0-9]/,'/',/[0-1]/,/[0-9]/,'/',/[0-9]/,/[0-9]/,/[0-9]/,/[0-9]/];

    filters = {
        customers: {list: [], options: null, selected: []},
        consultant: {list: [], options:null, selected: []},
        project: {list: [], options: null, selected: []},
        status: {list: [], options: null, selected: []},
        industry: {list: [], options: null, selected: []},
        excellenceCenter: {list: [], options: null, selected: []},
        supportCenter: {list: [], options: null, selected: []},
        statusFinancial: {
            list: [
                { id: 1, itemName: 'Aprovação pendente' },
                { id: 2, itemName: 'Pagamento pendente' },
                { id: 3, itemName: 'Pago' },
                { id: 4, itemName: 'Reprovado' }
            ],
            options: null, selected: []},
        divisions: {list: [], options: null, selected: []},
        subDivision: {list: [], options: null, selected: []},
        groups: {list: [], options: null, selected: []},

        limit: {list: [5, 10, 50, 100], selected: 10},
        startDate: null,
        endDate: null,
        skip: 0
    };
    loading: boolean;
    companyGroupSearchModel: any;
    companyGroups: any;
    allSubDivisions: any = [];
    allExcellenceCenters: any = [];

    constructor(private json2csvService: Json2csvService,
                private queryStringFactory: UrlBuilderFactory,
                private refundsService: RefundsService,
                private dropdownItemFactory: DropdownItemFactory,
                private dropdownSettingsFactory: DropdownSettingsFactory,
                private router: Router,
                private refundFiltersFactory: RefundFiltersFactory,
                private localStorage: LocalStorage,
                private companyService: CompanyService,
                private toastr: ToastsManager,
                private projectFinancialService: ProjectFinancialService,
                private excellenceCentersService : ExcellenceCentersService,
                private industriesService: IndustriesService) {
    }

    async ngOnInit() {
        this.loading = true;
        let refundsFilters = await this.refundsService.getProjectCustomersStatus(); //Substituição filterFactory - Returna arrays para popular os filtros

        this.filters.customers.list = this.dropdownItemFactory.build({source: refundsFilters.customers});
        this.filters.consultant.list = this.dropdownItemFactory.build({source: refundsFilters.consultants});
        this.filters.project.list = this.dropdownItemFactory.build({source: refundsFilters.projects});
        this.filters.status.list = this.dropdownItemFactory.build({source: refundsFilters.status});
        this.filters.divisions.list = this.commonHelper.getDropDownListItemsEnum(this.commonHelper.getAllGroups(), "GroupDivision");
        this.filters.groups.list = this.commonHelper.getDropDownListItems(await this.companyService.getAllCompanyGroups(), "_id", "name")
        this.filters.industry.list = this.commonHelper.getDropDownListItems(await this.industriesService.getAll(), "_id", "name");
        this.filters.excellenceCenter.list = this.commonHelper.getDropDownListItems(await this.loadAllExcellenceCenters(1), "_id", "name");
        this.filters.supportCenter.list = this.commonHelper.getDropDownListItems(await this.loadAllExcellenceCenters(2), "_id", "name");

        this.filters.status.options = this.dropdownSettingsFactory.build({text: "Status FCTeam"});
        this.filters.statusFinancial.options = this.dropdownSettingsFactory.build({text: "Status Financial"});
        this.filters.customers.options = this.dropdownSettingsFactory.build({text: "Clientes"});
        this.filters.consultant.options = this.dropdownSettingsFactory.build({text: "Consultores"});
        this.filters.project.options = this.dropdownSettingsFactory.build({text: "Projetos"});
        this.filters.divisions.options = this.dropdownSettingsFactory.build({text: "Divisões"});
        this.filters.groups.options = this.dropdownSettingsFactory.build({text: "Grupo de Empresas"});
        this.filters.industry.options = this.commonHelper.getDropDownSettings(false, 'Setores', true, 'Marcar todas as setores', 'Desmarcar todas as setores', true, '', '');
        this.filters.excellenceCenter.options = this.commonHelper.getDropDownSettings(false, 'Centros de Excelência', true, 'Marcar todas as Centros de Excelência', 'Desmarcar todas as Centros de Excelência', true, '', '');
        this.filters.subDivision.options = this.commonHelper.getDropDownSettings(true, 'Frente de Negócio', false, 'Marcar todas as subdivisões', 'Desmarcar todas as subdivisões', true, 'division', '');
        this.filters.supportCenter.options = this.commonHelper.getDropDownSettings(false, 'Áreas de Suporte', true, 'Marcar todas as Áreas de Suporte', 'Desmarcar todas as Áreas de Suporte', true, '', '');

        this.filters.startDate = moment().startOf('month').format('DD-MM-YYYY');
        this.filters.endDate = moment().endOf('month').format('DD-MM-YYYY');

        this.filters = await this.refundFiltersFactory.build(this.filters);

        await this.loadAllSubDivisions();
        this.onDivisionChange();
        await this.search(1);
        this.loading = false;
    }

    @HostListener('window:keyup', ['$event'])
    keyEvent(event: KeyboardEvent) {

        if (event.keyCode === 13) {
            this.search(1);
        }
    }

    async loadAllSubDivisions(){
        this.allSubDivisions = await this.projectFinancialService.getAllSubDivisions();
    }

    async loadAllExcellenceCenters(type){
        this.allExcellenceCenters = await this.excellenceCentersService.getAll()
        return this.allExcellenceCenters.filter(center => center.type == type );
    }

    onDivisionChange() {
        this.filters.subDivision.selected = [];
        this.filters.subDivision.list = [];

        if(this.filters.divisions.selected.length > 0) {
            this.filters.divisions.selected.forEach(divisionSelected => {
                let subDivisions = this.allSubDivisions.find((subdivision: any) => subdivision.division == divisionSelected.id);
                if(subDivisions){
                    this.filters.subDivision.list = [
                      ...this.filters.subDivision.list,
                      ...subDivisions.subDivision.map((item: any) => {
                        return {
                          id: item.code,
                          itemName: item.name,
                          'division': this.commonHelper.transcriptDivisionGroup(subDivisions.division)
                        }
                      })
                    ]
                }
            });
        }
    }

    async search(page, toexport?) {
        this.loading = true;
        let response
        try {
            if (toexport) {
                response = await this.refundsService.getAll(this.queryStringFactory.build(this.loadFilters(page, toexport)));
            } else {
                response = await this.refundsService.getAll(this.queryStringFactory.build(this.loadFilters(page)));
            }
        } catch (error) {
            console.log(error);            
        }

        if(response.count){
            this.totalItems = response.count
        }

        this.refunds = response.result;

        this.generateIndex();
        this.loading = false;
    }

    generateIndex(){
        let index = 0;
        this.refunds.map(item => {
            index++;
            item.index = index;
        });
    }

    loadFilters(page?, toexport?) {
        this.currentPage = page ? page : (this.currentPage ? this.currentPage : 1);

        let filters = {skip:0};

        _.forOwn(this.filters, (value, key) => {
            const selected = _.get(value, 'selected', value);
            if (selected == 'undefined' || selected == null) return;

            filters[key] = selected;
            filters[key] = _.isArray(filters[key]) ? filters[key].map(item => _.get(item, 'id')) : filters[key];
        });
        filters.skip = (this.currentPage - 1) * this.filters.limit.selected;
        if (toexport){
            delete filters.skip;
        }

        return filters;
    }

    async export() {
        this.loading = true;

        await this.search(1, true);
        let dataRefunds = [];
        const verifySupportCenter = (refund: Refund & {supportCenter: {name: string}}): string => {
            if (!VerifyCreatedDate(refund)) return '-'
            const isSupportCenterDefined = !!refund.supportCenter && !!refund.supportCenter.name;
            return isSupportCenterDefined ? refund.supportCenter.name : "OTHERS";
        };
        this.refunds.forEach(refund => {

            let statusPago = (refund.status.name == 'Pago') ? moment(refund.status.updated).utc().format("DD/MM/YYYY") : "-";
            let statusAprovado = "-";
            if(refund.status.name == 'Aprovado')
                statusAprovado = moment(refund.status.updated).utc().format("DD/MM/YYYY");
            else{
                refund.status_updated.forEach(status => {
                    if(status._id == '59889142cd3cf300257d071f') statusAprovado = moment(status.updated).utc().format("DD/MM/YYYY");
                })
            }
            const approvers = this.transcriptApprovers(refund)
            .replaceAll('&#10004;', 'S')
            .replaceAll('&#10006;', 'N')
            .replaceAll('&#8857;', '')
            .replaceAll('&#9679;', '');

            let supportCenter = verifySupportCenter(refund);
            refund.expenses.forEach(expense => {
                let cnpjAlternative = refund.consultant.cnpj ? refund.consultant.cnpj : "-";
                let dataExpense = {
                    "ID Reembolso": refund._id,
                    "Número Reembolso": refund.number ? refund.number : "-",
                    "CNPJ consultor": cnpjAlternative,
                    "Nome empresa consultor": refund.consultant.companyName ? refund.consultant.companyName.trim() : "-",
                    "Nome consultor": refund.consultant.name ? refund.consultant.name.trim() : "-",
                    "Código PN": refund.sapCardCode ? refund.sapCardCode : "-",
                    "Valor despesa": expense.value ? expense.value.toLocaleString("pt-BR",{maximumFractionDigits : 3}) : "-",
                    "Data da despesa": expense.date ? moment(expense.date).utc().format("DD/MM/YYYY") : "-",
                    "Data solicitação": refund.created ? moment(refund.created).utc().format("DD/MM/YYYY") : "-",
                    "Data aprovação": statusAprovado,
                    "Data pagamento": statusPago,
                    "Grupo de empresa": expense.companyGroup ? expense.companyGroup.name : "-",
                    "Cliente alocado": expense.customer.name ? expense.customer.name : "-",
                    "Setor": expense.industry && expense.industry.name && VerifyCreatedDate(refund) ? expense.industry.name : "-",
                    "Centro de Excelência": refund.excellenceCenter && VerifyCreatedDate(refund) ?  refund.excellenceCenter.name : "-",
                    "Área de Suporte": supportCenter,
                    "Projeto": expense.project.name ? expense.project.name : "-",
                    "Divisão": this.getProjectOrConsultantDivision(refund, expense),
                    "Frente de Negócio": !VerifyCreatedDate(refund) && expense.subDivision ? expense.subDivision.name : "-",
                    "Status_FCTeam": refund.status.name ? refund.status.name : "-",
                    "Status_Financial": refund.statusFinancial ? this.commonHelper.transcriptStatusRefund(refund.statusFinancial) : "-",
                    "Aprovadores": approvers,
                    "Classificação": expense.classificationName ? expense.classificationName : "-",
                    "Descrição": expense.description ? expense.description : "-"
                }
                dataRefunds.push(dataExpense);
            })
        })
        this.json2csvService.export(dataRefunds,
            `relatório de reembolsos - ${new Date().toLocaleDateString('pt-br')}s`
        );

        this.loading = false;
    }

    verifyDate(date,field){
        if(!(new RegExp(this.datePattern).test(date))){
            this.toastr.warning(`Digite uma data válida.`,"Data inválida!");
            this.filters[`${field}`] = null;
        } else if(this.filters.startDate && this.filters.endDate) {
            const startDate = moment(this.filters.startDate, "DD/MM/YYYY");
            const endDate = moment(this.filters.endDate, "DD/MM/YYYY");
            if(endDate < startDate){
                this.toastr.warning('A data final não pode ser menor que a data inicial');
                this.filters.endDate = null;
            }
        }
    }

    saveFilters() {
        this.localStorage.save(this.loadFilters(), 'refunds')
    }

    getProjectOrConsultantDivision(refund: Refund, expense: {project: {division: GroupDivision}}) {
        if (expense && expense.project.division && !VerifyCreatedDate(refund)) {
           return this.commonHelper.transcriptDivisionGroup(expense.project.division)
        }

        if (refund && refund.consultant.division && !VerifyCreatedDate(refund)) {
            return this.commonHelper.transcriptDivisionGroup(refund.consultant.division)
        }

        return "-"
    }

    transcriptSubDivisions(expenses, refund: Refund) {
        if (VerifyCreatedDate(refund)) return "-";

        let subDivisions = expenses.filter(expense => expense.subDivision && expense.subDivision.name)
            .map(item => item.subDivision.name);
        if(subDivisions.length > 0)
            return subDivisions
                .filter((item, pos) => subDivisions.indexOf(item) == pos)
                .join(' / ');
        return "-";
    }

    transcriptApprovers(refund) {
        if (refund.approvers && refund.approvers.length) {
            const notFalsyRefundApprovers = refund.approvers.filter(approver => approver !== null && approver !== undefined);
            let refundApprovers = notFalsyRefundApprovers
                .map(
                    (m) =>
                        `${m.optional ? "&#8857;" : "&#9679;"} ${m.name} ${
                            m.approved ? "(&#10004;)" : "(&#10006;)"
                        }`
                )
                .join(" / ");
            return refundApprovers;
        }

        if (refund.approver) {
            return `&#9679; ${refund.approver.name} ${
                refund.approver ? "(&#10004;)" : "(&#10006;)"
            }`;
        }

        return "";
    }

    hasPermission(refund: Refund): void {
        const currentUser = this.localStorage.retrieve('user')

        if(currentUser.permission === GUARDS.GOVERNANCE && refund.value > 25000) {
            this.toastr.warning('Você não possui permissão para acessar este reembolso, o valor ultrapassa o limite de aprovação', 'Operação bloqueada')
            return
        }

        this.router.navigate([`/refunds/edit/${refund._id}`])
    }

    verifyColorColumn(status: number) {
        switch(status){
            case 1: return "aprovacao-pendente";
            case 2: return "pagamento-pendente";
            case 3: return "pago";
            case 4: return "reprovado";
            default: return '';
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/views/refunds-report/refunds-report.component.ts